import React from 'react'
import {Button, CircularProgress, Snackbar } from '@material-ui/core'
import {Alert} from "@mui/material";
import {DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import {get, noop} from 'lodash/fp';
import {connect} from "react-redux";
import {getSelectedTeam, getSelectedTeamsPairings} from "../../reducers/teamSelectors";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import {ACCEPTED} from "../../consts/status";
import Unauthorized from "../Unauthorized";
import Typography from "@material-ui/core/Typography";
//import {dateFormater, timeFormater} from "../../utils/dateUtils";
import {format} from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import {friendlyRoundName, CustomTooltip} from "../helpers";
import {getCurrentMoot} from '../../reducers/mootSelectors'
import MapAndLocationButtons from 'components/common/MapAndLocationButtons';
import TeamName from "./TeamName";
import SwipeHorizontalInstruction from "../common/SwipeHorizontalInstruction"
import {isNotEmpty} from "../../utils/funcUtils";
import {getFileUrl} from "../../actions/fileActions";
import {triggerFileDownloadFromUrl} from "../../utils/fileUtils";

LicenseInfo.setLicenseKey(
    '19a99a1195c5f52fabd5f3310b083226T1JERVI6Mjk5MzAsRVhQSVJZPTE2NjQxNDA4NTIwMDAsS0VZVkVSU0lPTj0x',
);

const OralArguments = ({
                           team = {},
                           moot,
                           selectedTeamsPairings = [],
                           getSelectedTeam = noop,
                           getCurrentMoot = noop,
                           getSelectedTeamsPairings = noop,
                           getFileUrl = noop
                       }) => {
    const [busy, setBusy] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(false)
    const [snackbarSeverity,setSnackbarSeverity] = React.useState('info');
    const [snackbarMessage,setSnackbarMessage] = React.useState('');

    React.useEffect(() => {
        const asyncFetchData = async () => {
            try {
                setIsLoading(true)
                await getCurrentMoot()
                await getSelectedTeam()
                await getSelectedTeamsPairings()
                setIsLoading(false)                
            }catch(e){
                //TODO ?
                setIsLoading(false)
            }
        }
        asyncFetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const checkForTeamResults  = async () => {
        //call the API to get the time bombed document URL
        // TODO refactor the api to support a document that is not time bombed
        try {
            setBusy(true)

            setSnackbarSeverity('info')
            setSnackbarMessage("Checking for Team Results")
            const fileName = `${moot.id}_TEAM_${team.id}_team_results.pdf`;
            const url = await getFileUrl('TEAM_RESULTS', fileName)
            if (isNotEmpty(url)) {
                // if we get one back then open the document
                triggerFileDownloadFromUrl(url,fileName)
                setSnackbarSeverity('success')
                setSnackbarMessage("Downloaded Team Results")
            } else {
                // if we don't then show a snackbar with "No document found""
                setSnackbarSeverity('error')
                setSnackbarMessage("No Team Results found")
            }
        }finally {
           // handClose will setBusy to false
        }
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setBusy(false)
    };


    const columns = [       
        {
            field: 'Date',
            headerName: 'Date',
            align: 'right',
            width: 130,
            sortable: false,
            //renderCell: params => dateFormater(params.row.pairing.pairingTime)
            renderCell: params => format(utcToZonedTime(params.row.pairing.pairingTime,'Asia/Hong_Kong'),'iii, dd MMMM'),
            valueGetter: params => format(utcToZonedTime(params.row.pairing.pairingTime,'Asia/Hong_Kong'),'yyyy/MM/dd HH:mm'),
            
        },
        {
            field: 'time',
            headerName: 'Time',
            align: 'right',
            width: 90,
            sortable: false,
            //renderCell: params => timeFormater(params.row.pairing.pairingTime)
            valueGetter: params => format(utcToZonedTime(params.row.pairing.pairingTime,'Asia/Hong_Kong'),'h:mm aaa')
        },
        {
            field: 'claimant',
            headerName: 'Claimant',
            flex: 1,
            minWidth: 140,
            sortable: false,
            renderCell: params => (<a href={`${params.row.claimantDocUrl}`}><TeamName team={params.row.claimant} /></a>)
        },
        {
            field: 'respondent',
            headerName: 'Respondent',
            flex: 1,
            minWidth: 140,
            sortable: false,
            renderCell: params => (<a href={`${params.row.respondentDocUrl}`}><TeamName team={params.row.respondent}/></a>)
        },
        {
            field: 'room',
            headerName: 'Room',
            flex: 1,
            minWidth: 140,
            sortable: false,
            renderCell: params => {
                if (!get('row.pairing.room',params)){
                    return <CustomTooltip content='available soon' />
                } else {
                    return <CustomTooltip content={params.row.pairing.room} />
                }
            }
        },
        /*
        {
            field: 'hearingLink',
            headerName: 'Virtual Hearing Link',
            flex: 1,
            sortable: false,
            renderCell: params => {
                if (!get('row.pairing.hearingLink',params)){
                    return (<span>coming soon</span>)
                }else{
                    return (<a target="_blank" rel="noreferrer" href={`${get('row.pairing.hearingLink',params)}`}>Click Here</a>)
                }
            }
        },
        */
                          
        {
            field: 'chairArbitrator',
            headerName: 'Arbitrator',
            flex: 1,
            minWidth: 140,
            sortable: false,
            valueGetter: params => {
                 if(moot.showOralDetailsArbitratorsOpenDate?.notYetOpen === true) {
                    return '—'
                 } else {
                    return `${get('pairing.chairArbitrator.firstName',params.row)?? ''} ${get('pairing.chairArbitrator.lastName',params.row)?? ''}`
                 }
                }
            },
        {
            field: 'secondArbitrator',
            headerName: 'Arbitrator',
            flex: 1,
            minWidth: 140,
            sortable: false,
            valueGetter: params => {
                if(moot.showOralDetailsArbitratorsOpenDate?.notYetOpen === true) {
                   return '—'
                } else {
                   return `${get('pairing.secondArbitrator.firstName',params.row)?? ''} ${get('pairing.secondArbitrator.lastName',params.row)?? ''}`
                }
            }
        },
        {
            field: 'thirdArbitrator',
            headerName: 'Arbitrator',
            flex: 1,
            minWidth: 140,
            sortable: false,
            valueGetter: params => {
                if(moot.showOralDetailsArbitratorsOpenDate?.notYetOpen === true) {
                   return '—'
                } else {
                   return `${get('pairing.thirdArbitrator.firstName',params.row)?? ''} ${get('pairing.thirdArbitrator.lastName',params.row)?? ''}`
                }
            }
        },
        {
            field: 'roundType',
            headerName: 'Round',
            flex: 1,
            minWidth: 120,
            sortable: false,
            valueGetter: params => friendlyRoundName(get('pairing.roundType',params.row))
        },
              
        ]

    const isAllowed = get('status',team) === ACCEPTED
    const isPending = get('status',team) === null


    return (
            <Container maxWidth='xl'>                
                { isLoading &&
                <CircularProgress />
                }
                {!isLoading && !isAllowed && !isPending &&
                <Unauthorized />
                }
                { !isLoading && isPending && <div style={{ marginLeft: '4rem' }}>
                <Typography variant='h5' component='h1'>This section it not yet available</Typography>
                </div>}
                {!isLoading && isAllowed && moot.showOralDetailsTeamOpenDate.notYetOpen === true &&
                       <>
                       <Typography variant='h4' component='h1'>Oral Arguments</Typography> 
                       <Typography style={{marginTop: '1rem'}}>The schedule is still tentative and being finalized. The Vis East Administration will send an email when the schedules are finalized.</Typography>
                       </>
                }
                {!isLoading && isAllowed && moot.showOralDetailsTeamOpenDate.notYetOpen === false &&
                <>
                    <Typography variant='h4' component='h1' style={{marginBottom: '0.875rem'}}>Oral Arguments</Typography>
 
                    <Button color="primary" 
                            style={{backgroundColor: '#dd1f26', lineHeight: '1', padding: '8px 14px 8px 10px', marginBottom: '0.875rem'}}
                            variant="contained" 
                            size="small"                          
                            onClick={() => checkForTeamResults()}
                            >                        
                            Download Team Results
                    </Button>

                    <MapAndLocationButtons />              
                    <div style={{margin: '1rem 0 2rem', width: '100%'}}>
                        <DataGridPro                            
                            rows={selectedTeamsPairings || []}                            
                            autoHeight                            
                            //Use the line below instead, if you just want the first two pairings
                            //rows={take(2,selectedTeamsPairings) || []}
                            columns={columns}
                            disableSelectionOnClick
                            hideFooter                            
                        />
                        <SwipeHorizontalInstruction />
                    </div>
                    <Typography>
                    Please see above your schedule for the General Rounds. The schedule may change due to various factors. You will be notified if changes occur.
                    </Typography>
                    <Typography><strong><u>ALL</u></strong> oral argument swill take place <strong>in person</strong> at the West Wing, Justice Place, 11 Ice House Street (on the corner of Ice House Street and Queens Road Central), in Central on Hong Kong Island. The Vis East Centre is located on the second floor (2/F). Room numbers will be available on your schedule once they have been finalized. If no room number appears, you will receive such information when you check-in with the Vis East Centre. Teams are requested to arrive <strong><u>no earlier</u></strong> than <strong><u>15 minutes</u></strong> in advance of their oral argument and <strong><u>no later</u></strong> than <strong><u>10 minutes</u></strong> before their scheduled oral argument to check in with the Vis East Administration.</Typography>              
                    <Typography>
                    As a kind reminder, pursuant to the Vis East Rules, no team shall practice with, plead against, or watch a team that it is scheduled to meet in the general rounds. Teams are also prohibited from the viewing of arguments in practice rounds (including pre-moots) of teams that they are scheduled to plead against in the general rounds. Any violation of the Vis East Rules will <strong>immediately disqualify</strong> a team from participation in the elimination rounds. Please make sure that you are familiar with the Vis East Rules. For any questions or concerns, please email the Vis East Administration at: <a href="mailto:info@cisgmoot.org" className="color-blue">info@cisgmoot.org</a>.
                    </Typography>
                </>
                }
                <Snackbar open={busy} onClose={handleClose} autoHideDuration={6000} >
                    <Alert severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Container>
    )
}



OralArguments.propTypes = {
    teamMembers: PropTypes.arrayOf(PropTypes.object),
    getSelectedTeam: PropTypes.func,
    getSelectedTeamsPairings: PropTypes.func
}

export default connect(
    (state, ownProps) => ({
        team: state.team.selectedTeam,
        moot: state.moot.currentMoot,
        selectedTeamsPairings: state.team.selectedTeamsPairings
    }),{
        getSelectedTeam: getSelectedTeam,
        getSelectedTeamsPairings: getSelectedTeamsPairings,
        getCurrentMoot: getCurrentMoot,
        getFileUrl: getFileUrl
    })( OralArguments)